import React, { useEffect, useState } from "react";
import { BarChart3 } from "lucide-react";
import MonthlyRevenueCard from "./MonthlyRevenue";
import SupportTicketCard from "./SupportTicket";
import TotalAccountCard from "./TotalAccount";
import ActiveAccountCard from "./ActiveAccount";
import UserGrowthCard from "./UserGrowth";
import AccountTypesCard from "./AccountTypes";
import MonthlyRevenueGraphCard from "./MonthlyGraphRevenue";
import DailyActivity from "./DailyActivity";
import SingleSelectNew from "../../../components/SelectField/SingleSelectNew";

const Analytics = () => {
  const [timeRange, setTimeRange] = useState("30days");

    const dateOptions = [
    { value: "7days", label: "Last 7 Days" },
    { value: "30days", label: "Last 30 Days" },
    { value: "90days", label: "Last 90 Days" },
    { value: "1year", label: "Last Year" },
  ];

    const handleDateChange = (e) => {
    setTimeRange(e);
  };
  return (
    <div className="p-24 max-w-7xl mx-auto">
      <div className="flex justify-between items-center mb-24">
        <div>
          <h1 className="text-2xl font-bold flex items-center text-foreground">
            <BarChart3 className="mr-8 h-6 w-6 text-blue-500" />
            Analytics & Reports
          </h1>
          <p className="text-gray-500 mt-4">
            Comprehensive system analytics and performance metrics
          </p>
        </div>
        <div>
          <div className="mt-12 sm:mt-0">
          <SingleSelectNew
            contentClass="bg-white text-black border-gray-300 dark:bg-[#2c3440] dark:text-white dark:border-[#464c59]"
            className="w-[180px]"
            itemClass="hover:bg-gray-100 dark:hover:bg-[#3c4351]"
            value={timeRange}
            onChange={handleDateChange}
            options={dateOptions}
          />
        </div>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-24">
        <TotalAccountCard timeRange={timeRange} />
        <ActiveAccountCard timeRange={timeRange} />
        <MonthlyRevenueCard timeRange={timeRange} />
        <SupportTicketCard timeRange={timeRange} />
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-24">
        <UserGrowthCard timeRange={timeRange} />

        <MonthlyRevenueGraphCard timeRange={timeRange} />
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <AccountTypesCard timeRange={timeRange} />
        <DailyActivity timeRange={timeRange} />
      </div>
    </div>
  );
};

export default Analytics;
